import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { ProductsService } from '../../../products/products.service';
import { IBundleItem } from '../../models/models';
import { BundlesService } from '../../services/bundles.service';

class BundleDetailsComponent {
    public static $inject = [
        '$localStorage',
        'notificationService',
        'bundlesService',
        '$state',
        '$translate',
        'popupService',
        'productsService'
    ];

    public waiting = false;
    public countryID: number;
    public bundleID: number;
    public bundle: IBundleItem;
    public dateFormat = 'dd/MM/yyyy';

    constructor(
        private $localStorage: ngStorage.StorageService,
        private notificationService: NotificationService,
        private bundlesService: BundlesService,
        private $state: StateService,
        private $translate: angular.translate.ITranslateService,
        private popupService: PopupService,
        private productService: ProductsService
    ) {
    }

    public async $onInit() {
        this.bundleID = parseInt(this.$state.params.id, 10);
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
        await this.loadData();
    }

    public getLogoImage(logoID?: number): string {
        return logoID ? this.bundlesService.getLogoImageUrl(logoID, 240, 120) : '';
    }

    public getVariationImage(id: string): string {
        return this.bundlesService.getVariationImageUrl(id);
    }

    public async confirmDeleteBundle() {
        if (this.waiting) {
            return;
        }
        try {
            this.waiting = true;
            const result = await this.popupService.confirm({
                title: this.$translate.instant('bundle_delete_title'),
                content: `<span style="word-break: break-word">${this.$translate.instant(
                    'bundle_delete_content',
                    { name: this.bundle.Name }
                )}</span>`,
                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                okClass:
                    'btn btn-with-icon btn-with-icon--before-delete btn-danger flexVerticalAlignParent',
                classPopup: 'popup--redesign modal360',
                cancelTxt: this.$translate.instant('cancel'),
                okTxt: this.$translate.instant('delete'),
                hasIcon: true,
                thinTitle: true
            });
            if (result) {
                this.waiting = false;
                await this.deleteBundle();
            }
        } catch (e) {
            this.waiting = false;
            return;
        }
    }

    private async deleteBundle() {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            await this.bundlesService.deleteBundle(this.bundleID);
            this.notificationService.showSuccessMessage();
            this.waiting = false;
            this.$state.go('app.bundles');
        } catch (error) {
            this.waiting = false;
            this.notificationService.showErrorMessage(error);
        }
    }

    private async loadData() {
        if (this.waiting) {
            return;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            const metadata = await this.productService.getMetadata();
            this.bundle = await this.bundlesService.getBundle(this.bundleID);
            this.bundlesService.fillSizeAndColourNames(this.bundle, metadata);
            this.waiting = false;
            this.notificationService.clearAll();
        } catch (error) {
            this.waiting = false;
            this.notificationService.showErrorMessage(error);
        }
    }

}
angular.module('naut').component('bundleDetailsComponent', {
    template: require('./bundle-details.component.html'),
    controller: BundleDetailsComponent,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/bundles/components/bundle-details/bundle-details.component.ts